module.exports = __webpack_public_path__ + "static/media/31.5f4dbe74.jpg";